<template>
	<div class="page-container">
		<md-app md-mode="fixed">
			<md-app-toolbar class="md-primary">
				<md-button class="md-icon-button" @click="backHome()">
					<md-icon>arrow_back</md-icon>
				</md-button>
				<span class="md-title" style="font-size: 15px; font-weight: bold;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 240px; margin-left: 0;">
					Pré-Aposta
				</span>
				<span v-if="PIXEnabled()" class="md-title" style="right: 10px;position: absolute; cursor: pointer;" @click="gerarPIXQRCode(bet.numeroBilhete)">
                    <img class="titan-logo" src="../assets/logo_pix.png">
                </span>
			</md-app-toolbar>
			<md-app-content style="padding: 5px;padding-top: 0px;">
				<md-empty-state style="color: white;" class="no-event-found"
				md-icon="sentiment_very_dissatisfied" v-if="betNotFound"
				:md-label="msg">
				<md-button class="md-raised md-accent" v-on:click="backHome()">
					VOLTAR
				</md-button>
				</md-empty-state>
				<div class="md-layout md-gutter md-alignment-center-center" v-if="loadingBet">
					<img class="titan-logo" src="../assets/loading.gif" style="width: 90px;">
				</div>
				<div v-if="!loadingBet && !betNotFound" class="fundo-ticket-number zig-zag-top zig-zag-bottom">
					<div class="md-layout">
						<div class="md-layout-item logo">
							<img class="titan-logo" src="../assets/titan_logo.png">
						</div>
					</div>
					<div class="md-layout">
						<div class="md-layout-item" style="padding-left: 10px; padding-right: 10px; margin-top: 10px;">
							<div class="md-layout fundo-ticket-number-even" style="border: 1px solid black; padding: 0; ">
								<table style="width: 100%;">
									<tr>
										<td style="width: 50%;border-right: 1px solid black;">
											<div class="md-layout-item md-size-100" style="font-size: 12px;">Pré-Aposta:</div>
											<div class="md-layout-item" style="text-align: center;font-size: 18px;">{{ bet.numeroBilhete }}</div>
										</td>
										<td>
											<div class="md-layout-item md-size-100" style="font-size: 12px;">Data:</div>
											<div class="md-layout-item" style="text-align: center;font-size: 17px;">{{ bet.momento }}</div>
										</td>
									</tr>
								</table>
							</div>
							<div class="md-layout fundo-ticket-number-even" style="border: 1px solid black; padding: 0; border-top: 0;">
								<table style="width: 100%;">
									<tr>
										<td style="width: 50%;border-right: 1px solid black;">
											<div class="md-layout-item md-size-100" style="font-size: 12px;">Valor Apostado:</div>
											<div class="md-layout-item" style="text-align: center;font-size: 18px;">{{ bet.valorPago }}</div>
										</td>
										<td>
											<div class="md-layout-item md-size-100" style="font-size: 12px;">Apostador:</div>
											<div class="md-layout-item" style="text-align: center;font-size: 18px;">{{ bet.apostador }}</div>
										</td>
									</tr>
								</table>
							</div>
							<div class="md-layout fundo-ticket-number-even" style="border: 1px solid black; padding: 0; border-top: 0;">
								<table style="width: 100%;">
									<tr>
										<td style="width: 50%;border-right: 1px solid black;">
											<div class="md-layout-item md-size-100" style="font-size: 12px;">Eventos:</div>
											<div class="md-layout-item" style="text-align: center;font-size: 18px;">{{ bet.qtdEventos }}</div>
										</td>
										<td>
											<div class="md-layout-item md-size-100" style="font-size: 12px;">Possível Retorno:</div>
											<div class="md-layout-item" style="text-align: center;font-size: 18px;">{{ bet.valorPremio }}</div>
										</td>
									</tr>
								</table>
							</div>
							<div class="md-layout">
								<div class="md-layout-item" style="text-align: center; font-weight: bold;">Apostas</div>
							</div>
							<div class="md-layout" v-for="(subevento, key) in bet.eventosBilhetes" v-bind:class="verifyOddEven(key)">
								<div class="md-layout-item" style="padding-top: 3px; padding-bottom: 3px; text-align: center;">
									<div class="md-layout">
										<div class="md-layout-item">{{ subevento.schedule }}</div>
									</div>
									<div class="md-layout">
										<div class="md-layout-item">{{ subevento.league }}</div>
									</div>
									<div class="md-layout">
										<div class="md-layout-item">{{ subevento.tituloEvento }}</div>
									</div>
									<div class="md-layout">
										<div class="md-layout-item">{{ subevento.tituloSubEvento }}: {{ subevento.label }} - {{ subevento.cotacao }}</div>
									</div>
									<!-- <div class="md-layout">
										<div class="md-layout-item" v-bind:class="verifyColorStatus(subevento.nomeStatus)">{{ subevento.nomeStatus }}</div>
									</div> -->
								</div>
							</div>
							<qrcode-vue :value="id" :size="size" level="H" style="text-align: center; margin-top: 10px; margin-bottom: 10px;"></qrcode-vue>
						</div>
					</div>
				</div>
			</md-app-content>
		</md-app>
	</div>
</template>
<script>

	import axios from 'axios'
	import QrcodeVue from 'qrcode.vue';

	export default {
		name: 'TitanTicket',
		components: {
			QrcodeVue
		},
		props: ['ticket'],
		data () {
			return {
				id: 0,
				loadingBet: true,
				betNotFound: false,
				bet: [],
				size: 150
			}
		},
        created() {
            this.id = this.$route.params.id;
        },
        methods: {
			PIXEnabled: function(){
                return this.$root.$data.PIX && !this.loadingBet && this.bet.eventosBilhetes.length > 1;
            },
        	backHome: function() {
        		this.$router.push({ name: 'TitanHome'})
        	},
        	verifyOddEven: function(key) {
				return {
					'fundo-ticket-number-odd': (key % 2 == 0),
					'fundo-ticket-number-even': (key % 2 != 0)
				}
			},
        	verifyColorStatus: function(status) {
				return {
					'status-pendente-text': (status == 'Pendente'),
					'status-win-text': (status == 'Ganhou'),
					'status-lose-text': (status == 'Perdeu'),
					'status-canceled-text': (status == 'Cancelado'),
					'status-closed-text': (status == 'Encerrado')
				}
			},
			gerarPIXQRCode: function(numero) {
                this.$router.push({ name: 'TitanPIXQRCode', params: { id: numero }})
            }
        },
        mounted() {

        	if (this.id == 0) return false;

        	axios
			.get(this.$root.$data.API_URL + 'prebet/' + this.id)
			.then(response => {
				// console.log(response.data);
				if (response.data.success) {
	        		this.bet = response.data.bet
	        	} else {
	        		this.betNotFound = true
	        		this.msg = response.data.message
	        	}
	        })
			.finally(() => this.loadingBet = false );
        }
	}
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine"; // Import the theme engine

@include md-register-theme("default", (
	primary: #000000, // The primary color of your brand
	accent: #CB1323 // The secondary color of your brand
	));

@import "~vue-material/dist/theme/all"; // Apply the theme

.logo {
	text-align: center;
	margin-top: 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/TitanTicket.vue